import React from "react";
import Navigation from "./Components/Navigation";
import FireBalls from "./Components/FireBalls";
import Team from "./Components/Team";
import Design from "./Components/Design";
import Insights from "./Components/Insights";
import DesignGuidelines from "./Components/DesignGuidelines";
import Concepts from "./Components/Concepts";
import Footer from "./Components/Footer";
import PartyPieper from "./Components/PartyPieper";

function App() {
  return (
    <>
      <Navigation />
      <FireBalls />
      <Team />
      <Design />
      <Insights />
      <DesignGuidelines />
      <Concepts />
      <Footer />
      <PartyPieper />
    </>
  );
}

export default App;
